"use client";
import React, { useState } from "react";
import Image from "next/image"; // Assuming you're using Next.js
import {
  childVariantsExtended,
  parentVariantsExtended,
} from "../constants/motion";
import { motion } from "framer-motion";

const defaultImage = "/images/services/custom-web-design.jpg";

const Services = ({
  leftposition = true,
  h2_title = "",
  h3_title = "",
  h3_coloredTitle = "",
  anchor_text = "",
  children,
  image,
}) => {
  const [imgSrc, setImgSrc] = useState(image.src || defaultImage);

  const handleError = () => {
    setImgSrc(defaultImage);
  };

  return (
    <>
      <a id={anchor_text}></a>
      <motion.section
        className="w-full "
        variants={parentVariantsExtended}
        initial="initial"
        whileInView="animate"
      >
        <div className="mx-5 lg:mx-auto h-full">
          {h2_title && (
            <h2 className="text-4xl text-center mx-4 md:mx-0 my-3 py-12">
              {h2_title}
            </h2>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-5 mb:0 md:mb-8 h:auto">
            {leftposition ? (
              <>
                <motion.div
                  variants={childVariantsExtended}
                  className="relative md:h-auto  min-h-56 md:min-h-0"
                >
                  <Image
                    fill
                    src={imgSrc}
                    alt={image.alt || "Service Image"}
                    className="absolute w-full h-auto object-cover rounded-2xl shadow-2xl"
                    onError={handleError}
                  />
                </motion.div>
                <div className="flex items-center justify-center">
                  <div className="order-2 md:order-2 mt-4 md:mt-0 py-2 md:py-12">
                    <motion.div
                      variants={childVariantsExtended}
                      className="text-lg leading-relaxed md:leading-loose"
                    >
                      <div className="flex items-center justify-center px-0 md:px-10">
                        <div className="p-2 md:p-8 text-black flex flex-col justify-center z-10">
                          <h3 className="text-4xl font-semibold mb-4">
                            {h3_title}
                            <span className="text-color-orange-400 pl-2">
                              {h3_coloredTitle}
                            </span>
                          </h3>
                          {children}
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-center order-2 md:order-1 py-2 md:py-12">
                  <div className="text-base mt-4 md:mt-0">
                    <motion.div
                      variants={childVariantsExtended}
                      className="text-lg leading-relaxed md:leading-loose"
                    >
                      <div className="flex items-center justify-center px-0 md:px-10">
                        <div className="p-2 md:p-8 text-black flex flex-col justify-center z-10">
                          <h3 className="text-4xl font-semibold mb-4">
                            {h3_title}
                            <span className="text-color-orange-400 pl-2">
                              {h3_coloredTitle}
                            </span>
                          </h3>
                          {children}
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>

                <motion.div
                  variants={childVariantsExtended}
                  className="relative order-1 md:order-2 min-h-56 md:min-h-0"
                >
                  <Image
                    fill
                    src={imgSrc}
                    alt={image.alt || "Service Image"}
                    className="w-full h-full object-cover rounded-2xl shadow-2xl"
                    onError={handleError}
                  />
                </motion.div>
              </>
            )}
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Services;
